'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import React__default, { useRef, useState, useEffect } from 'react';
import { WarpBody } from './index.css.js';
import translations from './translations.js';
import { updateSummaryProfileSetting, apiDoUpload, getUserContactInfo, apiGetResume } from './apiServices.js';
import { defaultProps, initWorkingReferenceData, DEFAULT_SUCCESS_CODE } from './constants.js';
import { ELanguage } from '../Utils/constants.js';
import { ETab } from './type.js';
import Popup from '../Popup/index.js';
import ResumeModalContext from './context/index.js';
import { AttachCV } from './Components/AttachCV.js';
import ContactInfo from './Components/ContactInfo.js';
import WorkingReference from './Components/WorkingReference.js';
import { Tabs } from './Components/Layouts/Tabs.js';
import Footer from './Components/Layouts/Footer.js';
import useHog from '../PostHog/hooks/useHog/index.js';
import { validateFile } from '../services/resumes/index.js';

var UploadResumeModal = function (props) {
    var _a = props.lang, lang = _a === void 0 ? ELanguage.VI : _a, _b = props.isHomepage, isHomepage = _b === void 0 ? false : _b, _c = props.isReloadOnClose, isReloadOnClose = _c === void 0 ? false : _c, 
    // jobLevelOptions = [],
    _d = props.jobLocationOptions, 
    // jobLevelOptions = [],
    jobLocationOptions = _d === void 0 ? [] : _d, _e = props.jobCategoryOptions, jobCategoryOptions = _e === void 0 ? [] : _e, _f = props.jobIndustryOptions, jobIndustryOptions = _f === void 0 ? [] : _f, _g = props.jobFunctionOptions, jobFunctionOptions = _g === void 0 ? {
        parent: [],
        child: {}
    } : _g, _h = props.customHeaderTitle, customHeaderTitle = _h === void 0 ? '' : _h, _j = props.isCloseable, isCloseable = _j === void 0 ? true : _j, _k = props.nationalityOptions, nationalityOptions = _k === void 0 ? [] : _k, _l = props.countryOptions, countryOptions = _l === void 0 ? [] : _l, _m = props.cityOptions, cityOptions = _m === void 0 ? [] : _m, _o = props.districtOptions, districtOptions = _o === void 0 ? [] : _o, _p = props.baseApiUrl, baseApiUrl = _p === void 0 ? 'https://staging-ms.vietnamworks.com' : _p, _q = props.apiUpload, apiUpload = _q === void 0 ? '/api-gateway/v2.0/profile/update-resume-file' : _q, accessToken = props.accessToken, _r = props.apiGetResumeInfo, apiGetResumeInfo = _r === void 0 ? '/api-gateway/v1.0/attached-resume' : _r, _s = props.apiAutoCompleteJobTitle, apiAutoCompleteJobTitle = _s === void 0 ? '/api-gateway/v1.0/suggest-job-title' : _s, _t = props.apiUpdateResume, apiUpdateResume = _t === void 0 ? '/api-gateway/v1.0/profile/attached-profile' : _t, _u = props.apiGetJobLevelList, apiGetJobLevelList = _u === void 0 ? 'https://ms.vietnamworks.com/meta/v1.0/job-levels' : _u, _v = props.logoutUrl, logoutUrl = _v === void 0 ? 'https://secure.vietnamworks.com/logout/en?client_id=3' : _v, _w = props.apiGetUserContactInfo, apiGetUserContactInfo = _w === void 0 ? '/api-gateway/v1.0/profile/contact' : _w, stepJump = props.stepJump, resumeId = props.resumeId, onClose = props.onClose, onCancel = props.onCancel, uploadedFile = props.uploadedFile, _x = props.isUncontactable, isUncontactable = _x === void 0 ? false : _x, checkBeforeSubmitForm = props.checkBeforeSubmitForm, _y = props.enableJobFunction, enableJobFunction = _y === void 0 ? false : _y, hiddenStep = props.hiddenStep, checkDoneStep = props.checkDoneStep, isReplace = props.isReplace;
    var contactInfoRef = useRef(null);
    var workingPreferenceRef = useRef(null);
    var _z = useState(props.isOpen || false), isOpen = _z[0], setIsOpen = _z[1];
    var _0 = useState(1), step = _0[0], setStep = _0[1];
    // Form
    var currentResumeId = useRef(resumeId);
    var tracking = useHog().tracking;
    // drag, drop zone
    // upload file
    var _1 = useState(false), isUploading = _1[0], setIsUploading = _1[1];
    var _2 = useState(uploadedFile), uploadFile = _2[0], setUploadFile = _2[1];
    var _3 = useState(false), isShowLoading = _3[0], setShowLoading = _3[1];
    var _4 = useState(undefined), uploadResponseData = _4[0], setUploadResponseData = _4[1];
    var _5 = useState(''), uploadErrorMessage = _5[0], setUploadErrorMessage = _5[1];
    var _6 = useState(defaultProps.initialData), contactInfo = _6[0], setContactInfo = _6[1];
    var _7 = useState(initWorkingReferenceData), workingPreferenceData = _7[0], setWorkingPreferenceData = _7[1];
    var t = function (text) {
        if (lang === 'vi') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var handleClosePopup = function () {
        setIsUploading(false);
        setUploadFile(undefined);
        // reset step to 1
        setStep(1);
        // Hide loading overlay
        setShowLoading(false);
        setIsOpen(false);
        if (isHomepage) {
            window.location.reload();
        }
        if (isReloadOnClose) {
            window.location.reload();
        }
        // DO reset all error alert
        onClose && onClose();
        props.onTogglePopup && props.onTogglePopup(false, uploadResponseData);
    };
    // End
    var validateResume = function (uploadFileInfo) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, validateFile({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                            file: uploadFileInfo,
                            baseUrl: baseApiUrl !== null && baseApiUrl !== void 0 ? baseApiUrl : '',
                            userId: 0,
                            jobId: 0
                        })];
                case 1:
                    response = _f.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) && ((_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.spam)) {
                        setUploadErrorMessage((_e = (_d = response === null || response === void 0 ? void 0 : response.meta) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : '');
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
                case 2:
                    error_1 = _f.sent();
                    console.error(error_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var doUploadFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, response, jobAlertData, responseMessage, error_2;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 7, , 8]);
                    setUploadFile(file);
                    setIsUploading(true);
                    setShowLoading(true);
                    return [4 /*yield*/, validateResume(file)];
                case 1:
                    isValid = _f.sent();
                    if (!isValid) {
                        setIsUploading(false);
                        setShowLoading(false);
                        return [2 /*return*/];
                    }
                    // Reset error message when file is valid
                    setUploadErrorMessage('');
                    return [4 /*yield*/, apiDoUpload(accessToken, lang, "".concat(baseApiUrl).concat(apiUpload), file, uploadResponseData === null || uploadResponseData === void 0 ? void 0 : uploadResponseData.id, isReplace)];
                case 2:
                    response = _f.sent();
                    setIsUploading(false);
                    setShowLoading(false);
                    if (!(response.status === DEFAULT_SUCCESS_CODE)) return [3 /*break*/, 5];
                    tracking({
                        eventName: 'js_profile_management:attachment_resume_upload_success'
                    });
                    setUploadResponseData(response.data);
                    setStep(2);
                    checkDoneStep && checkDoneStep(1, response);
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.extract_error) {
                        return [2 /*return*/];
                    }
                    jobAlertData = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.job_alert_data;
                    setWorkingPreferenceData(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, workingPreferenceData), (jobAlertData.title ? { jobTitle: jobAlertData.title } : undefined)), (jobAlertData.year_of_exp ? { yearsExperience: jobAlertData.year_of_exp } : undefined)), (jobAlertData.locationId ? { locations: [jobAlertData.locationId] } : undefined)), (jobAlertData.level ? { jobLevelId: jobAlertData.level } : undefined)), (jobAlertData.salary ? { salary: Number(jobAlertData.salary) } : undefined)), (jobAlertData.industry && jobAlertData.industry.length > 0
                        ? { industries: jobAlertData.industry }
                        : undefined)));
                    currentResumeId.current = (response === null || response === void 0 ? void 0 : response.id) || 0;
                    if (!(jobAlertData.summary && jobAlertData.summary !== '')) return [3 /*break*/, 4];
                    return [4 /*yield*/, updateSummaryProfileSetting({
                            url: baseApiUrl,
                            summary: (_c = jobAlertData.summary) !== null && _c !== void 0 ? _c : '',
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : ''
                        })];
                case 3:
                    _f.sent();
                    _f.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    if (typeof response.message === 'string') {
                        setUploadErrorMessage((_d = response.message) !== null && _d !== void 0 ? _d : '');
                    }
                    else {
                        responseMessage = response.message;
                        if (!(responseMessage === null || responseMessage === void 0 ? void 0 : responseMessage.Message)) {
                            return [2 /*return*/];
                        }
                        setUploadErrorMessage((_e = responseMessage.Message) !== null && _e !== void 0 ? _e : '');
                    }
                    _f.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_2 = _f.sent();
                    console.error(error_2);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        // Check if user is on boarding (just created account and logged in)
        // then show modal to ask them upload cv
        var checkNeedToShowProfileModal = function () {
            if (window.requireOnboarding !== undefined && window.requireOnboarding !== null) {
                if (window.requireOnboarding) {
                    setIsOpen(true);
                }
            }
        };
        checkNeedToShowProfileModal();
    }, []);
    var userContactInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, contactInfo_1, parsedTimestamp, parsedDate, transformedData;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getUserContactInfo(accessToken, lang, "".concat(baseApiUrl).concat(apiGetUserContactInfo))];
                case 1:
                    response = _c.sent();
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) {
                        contactInfo_1 = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.attributes;
                        parsedTimestamp = Date.parse(contactInfo_1.birthday);
                        parsedDate = new Date(parsedTimestamp);
                        transformedData = __assign(__assign({}, contactInfo_1), { isSearchable: Boolean(contactInfo_1.isSearchable), birthday: contactInfo_1.birthday ? parsedDate : null });
                        setContactInfo(transformedData);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getResumeInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resume, _a, title, yearOfExp, companyIndustry, city, highestDegree, industry, level, salary, jobFunction, error_3;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiGetResume(accessToken, lang, "".concat(baseApiUrl).concat(apiGetResumeInfo))];
                case 1:
                    resume = _f.sent();
                    if ((_b = resume === null || resume === void 0 ? void 0 : resume.data) === null || _b === void 0 ? void 0 : _b.extraInfo) {
                        _a = (_c = resume === null || resume === void 0 ? void 0 : resume.data) === null || _c === void 0 ? void 0 : _c.extraInfo, title = _a.title, yearOfExp = _a.yearOfExp, companyIndustry = _a.companyIndustry, city = _a.city, highestDegree = _a.highestDegree, industry = _a.industry, level = _a.level, salary = _a.salary, jobFunction = _a.jobFunction;
                        setWorkingPreferenceData({
                            jobTitle: title !== null && title !== void 0 ? title : '',
                            yearsExperience: yearOfExp !== null && yearOfExp !== void 0 ? yearOfExp : 0,
                            locations: city !== null && city !== void 0 ? city : [],
                            jobLevelId: level !== null && level !== void 0 ? level : 0,
                            highestDegreeId: highestDegree !== null && highestDegree !== void 0 ? highestDegree : 0,
                            salary: salary !== null && salary !== void 0 ? salary : 0,
                            isSearchable: 0,
                            companyIndustries: companyIndustry !== null && companyIndustry !== void 0 ? companyIndustry : [],
                            industries: industry !== null && industry !== void 0 ? industry : [],
                            resumeId: (_e = (_d = resume === null || resume === void 0 ? void 0 : resume.data) === null || _d === void 0 ? void 0 : _d.resumeId) !== null && _e !== void 0 ? _e : -1,
                            jobFunction: jobFunction !== null && jobFunction !== void 0 ? jobFunction : []
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _f.sent();
                    console.error(error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (stepJump)
            setStep(stepJump);
        var isPopupOpen = props.isOpen || isOpen;
        // Do get Job Level
        if (isPopupOpen) {
            // call API to get resume info
            getResumeInfo();
            userContactInfo();
        }
        // Lock body scroll
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isPopupOpen) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        else {
            removeOverflowClass();
        }
        // Component will unmount
        return function () {
            removeOverflowClass();
        };
    }, [props.isOpen, isOpen]);
    var renderBody = function () {
        var _a;
        switch (step) {
            case ETab.UPLOAD_CV:
                return React__default.createElement(AttachCV, { doUploadFile: doUploadFile, uploadErrorMessage: uploadErrorMessage });
            case ETab.CONTACT_INFORMATION:
                return (React__default.createElement(ContactInfo, { formData: contactInfo, ref: contactInfoRef, baseApiUrl: baseApiUrl, cityOptions: cityOptions, districtOptions: districtOptions, countryOptions: countryOptions, nationalityOptions: nationalityOptions, accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '', apiGetUserContactInfo: apiGetUserContactInfo, setContactInfo: setContactInfo, checkDoneStep: checkDoneStep }));
            case ETab.WORKING_PREFERENCE:
                return (React__default.createElement(WorkingReference, { isReloadOnClose: isReloadOnClose, ref: workingPreferenceRef, formData: workingPreferenceData, baseApiUrl: baseApiUrl, apiAutoCompleteJobTitle: apiAutoCompleteJobTitle, apiGetJobLevelList: apiGetJobLevelList, accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '', jobCategoryOptions: jobCategoryOptions, jobIndustryOptions: jobIndustryOptions, jobLocationOptions: jobLocationOptions, isUncontactable: isUncontactable, checkBeforeSubmitForm: checkBeforeSubmitForm, checkDoneStep: checkDoneStep, logoutUrl: logoutUrl, handleClosePopup: handleClosePopup, apiUpdateResume: apiUpdateResume, resumeId: (_a = currentResumeId.current) !== null && _a !== void 0 ? _a : 0, setWorkingPreferenceData: setWorkingPreferenceData, jobFunctionOptions: jobFunctionOptions, enableJobFunction: enableJobFunction }));
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    return (React__default.createElement(ResumeModalContext.Provider, { value: {
            t: t,
            lang: lang,
            isShowLoading: isShowLoading,
            setShowLoading: setShowLoading,
            uploadFile: uploadFile,
            setUploadFile: setUploadFile,
            isUploading: isUploading,
            setIsUploading: setIsUploading,
            step: step,
            setStep: setStep
        } },
        React__default.createElement(Popup, { text: { header: customHeaderTitle !== '' ? customHeaderTitle : t('Cập nhật thông tin hồ sơ đính kèm') }, styleOption: {
                size: 'md'
            }, onClickOutside: function () {
                if (!isCloseable)
                    return;
                handleClosePopup();
                onCancel && onCancel();
            }, onClose: function () {
                if (!isCloseable)
                    return;
                handleClosePopup();
                onCancel && onCancel();
            }, isShow: props.isOpen || false, option: { isShowClose: isCloseable, isCloseOnClickBackdrop: isCloseable }, lang: lang, custom: {
                bodyOverflow: 'visible',
                additionalFooterHeight: 88,
                footer: (React__default.createElement(Footer, { checkBeforeSubmitForm: checkBeforeSubmitForm, handleClosePopup: handleClosePopup, hiddenStep: hiddenStep, onSaveContactInfo: function () {
                        var _a;
                        (_a = contactInfoRef.current) === null || _a === void 0 ? void 0 : _a.onSubmit();
                    }, onSaveWoringPreference: function () {
                        var _a;
                        (_a = workingPreferenceRef.current) === null || _a === void 0 ? void 0 : _a.onSubmit();
                    }, workingPreferenceData: workingPreferenceData }))
            } },
            React__default.createElement(WarpBody.Container, null,
                React__default.createElement(Tabs, { contactInfo: contactInfo, hiddenStep: hiddenStep }),
                renderBody()))));
};

export { UploadResumeModal as default };
//# sourceMappingURL=index.js.map
